import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {  
  Modal,
  Card,
  Button,
  Header,
  Label,
  Icon,  
  Form,
  Confirm,
  Message
} from 'semantic-ui-react';
import { notificationActions } from '../../actions/notification.actions';
import PropTypes from 'prop-types';
import { history } from '../../helpers';
import { userConstants } from '../../constants/user.constants';
import moment from 'moment';

class NotificationConfigIndexScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
        notificationServerstatus: 'open',
        notificationServers: null,
        confirmOpen: false,
        confirmAction: null,
        confirmNotificationServer: null,
        confirmMessage: null,
        testCredentials: {},
        testNotificationServer: null,
        testError: null,
        testSuccess: null,
        me: null
    };
  }

  static get propTypes() { 
    return { 
        notificationServerstatus: PropTypes.string,
        notificationServers: PropTypes.any,
        confirmOpen: PropTypes.bool,
        confirmAction: PropTypes.string,
        confirmMessage: PropTypes.string,
        confirmNotificationServer: PropTypes.any,
        me: PropTypes.any,
        loading: PropTypes.bool
    }; 
  }

  componentDidMount() { 
    this.setState({testResult : null});
    this.fetchServers();
  }

  fetchServers() {
    const { dispatch } = this.props;         
    dispatch(notificationActions.fetch());
  }

  showConfirm(notificationServer, action) {
    const msg =  `Tem certeza que deseja remover a notificação ${notificationServer.Name}?`;
    this.setState({
      confirmOpen: true,
      confirmAction: action,
      confirmNotificationServer
      : notificationServer,
      confirmMessage: msg
    });
  }

  closeConfirm() {
    this.setState({ confirmOpen: false});
  }

  executeConfirm() {
    const { dispatch } = this.props;
    const { confirmNotificationServer
      , confirmAction } = this.state;
    if (confirmAction == 'remove') {
      dispatch(notificationActions.remove(confirmNotificationServer.Id)).then(() => this.fetchServers());
    }

    setTimeout(() => this.fetchServers(), 1000);

    this.setState({
      confirmOpen: false,
      confirmAction: null,
      confirmNotificationServer: null,
      confirmMessage: null
    });
  }

  handleChange(field, data) {        
    const { testCredentials } = this.state;    
    testCredentials[field] = data;    
    this.setState({ testCredentials });    
  }

  testAuth(notificationServer) {
    const { dispatch } = this.props;
    this.setState({testResult : null});
    dispatch(notificationActions.test(notificationServer.Id, this.state.testCredentials));    
  }

  goToCreate() {
    history.push('/notification/config/create');
  }

  render() {    
    const { notification, loading, me } = this.props;
    // Check Permission    
    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }
    
    return (
      <Fragment>
        <Confirm open={this.state.confirmOpen} content={this.state.confirmMessage} onCancel={() => this.closeConfirm()} onConfirm={() => this.executeConfirm()} />
        <Header>
          <h1>Notificações Configuradas</h1>   
        </Header>
        <div style={{textAlign:"right", marginBottom: "8px"}}>
          <Button primary onClick={this.goToCreate}>Nova Configuração</Button>
        </div>
        <Card.Group>
          { (!notification || (notification.Results && notification.TotalNumberOfRecords == 0)) &&
            <Card header='Nenhuma configuração' fluid />
          }

          { notification && notification.Results && notification.Results.map((item) => {           
            return <Card key={item.Id} fluid>
              <Card.Content>
                <Card.Header>
                  {item.Name}
                  <Label style={{float: "right"}} color={item.Enabled ? 'green' : 'red'}>
                    {item.Enabled ? 'Ativo' : 'Inativo'}
                  </Label>
                </Card.Header>
                <Card.Description>
                  <p><strong>Tipo:</strong> {item.Type.Name}</p>                  
                  <p><strong>Mensagem:</strong> {item.Message}</p>                                    
                  <p><strong>Tempo:</strong> {item.Args} minutos</p>                                    
                </Card.Description>  
              </Card.Content>              
              <Card.Content extra>                     
                  <Button size='mini' secondary icon onClick={() => history.push(`/notification/config/update/${item.Id}`) }>
                    <Icon name='edit' />
                    Alterar
                  </Button>

                  <Button size='mini' color='red' icon onClick={() => this.showConfirm(item, 'remove') }>
                    <Icon name='trash' />
                    Excluir
                  </Button>                  
              </Card.Content>          
            </Card>                      
          }) }
        </Card.Group>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { notification, users } = state;      
  return { 
    notification,
    loading: notification.loading,
    me: users.me || null
  };
}

const connectedNotificationConfigIndexScreen = connect(mapStateToProps)(NotificationConfigIndexScreen);
export { connectedNotificationConfigIndexScreen as NotificationConfigIndexScreen };
